import { takeWhile2lajz05xm93j8 as takeWhile } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Limit.mjs';
import { collect8rtp7i1ebpj9 as collect } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/flow/Collect.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForLambda3af3he42mmnh as initMetadataForLambda } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *waitForNetwork(_this__u8e3s4, $completion) {
  var tmp = _this__u8e3s4.e67();
  yield* collect(takeWhile(tmp, waitForNetwork$slambda_0()), $completion);
  return Unit_instance;
}
var waitForNetwork$slambdaClass;
function waitForNetwork$slambda() {
  if (waitForNetwork$slambdaClass === VOID) {
    class $ {
      *c69(it, $completion) {
        return !(it === true);
      }
      ld(p1, $completion) {
        return this.c69((p1 == null ? true : typeof p1 === 'boolean') ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    waitForNetwork$slambdaClass = $;
  }
  return waitForNetwork$slambdaClass;
}
function waitForNetwork$slambda_0() {
  var i = new (waitForNetwork$slambda())();
  var l = (it, $completion) => i.c69(it, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  waitForNetwork as waitForNetwork170u1djobkhlr,
};
//endregion

//# sourceMappingURL=NetworkMonitor.mjs.map
